var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.54199 26.5558L10.4331 22.667L18.2142 30.4524L14.3231 34.3413L6.54199 26.5559V26.5558Z",
    fill: "#B487FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2148 30.4495L37.5677 11.0967L41.4588 14.9878L22.106 34.3406L18.2148 30.4495Z",
    fill: "#B487FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.215 38.234L14.3223 34.3413L18.2134 30.4502L22.1061 34.3429L18.2151 38.234H18.215Z",
    fill: "#B487FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.23c1505cc1f1256e84a8c8c6e82be628.svg";
export { ForwardRef as ReactComponent };